import React from 'react';
import List from '@mui/material/List';
import { Tooltip, Fade } from '@mui/material';

import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { Button } from '@mui/material';
//import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
//import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
//import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';


import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

//import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import { useSelector, useDispatch } from "react-redux";
import { breadcrumbsActions } from "../../_services/essentials/store";
import {history} from "../../_services/essentials/helpers";

export default function MenuContent({ isCollapsed }) {

    const accessTo = useSelector(x => x.auth.accessTo);
    const selectedMenuIndex = useSelector(x => x.breadcrumbs?.selected_menu_index);

    const dispatch = useDispatch();

    const mainListItems = [
        { text: 'Discovery', icon: <DashboardCustomizeRoundedIcon />, url: '/discovery/identified_profiles', visibility: accessTo.USER_AND_ABOVE },
        { text: 'Projects', icon: <InboxOutlinedIcon />, url: '/user_projects', visibility: accessTo.PROSPECT_AND_ABOVE },
        { text: 'Inquiry', icon: <EmailRoundedIcon />, url: '/inquiry/add', visibility: accessTo.PROSPECT_AND_ABOVE },
        { text: 'My KOL/DOL', icon: <ViewListRoundedIcon />, url: '/master_profiles', visibility: accessTo.PROSPECT_AND_ABOVE },
        // { text: 'DOL Dedicated', icon: <ViewListRoundedIcon />, url: '/dol_profiles/dol_dedicated', visibility: accessTo.PROSPECT_AND_ABOVE },
        // { text: 'Added Profiles', icon: <AssignmentRoundedIcon />, url: '/master_profiles', visibility: accessTo.PROSPECT_AND_ABOVE },
    ];

    const totalMainListItems = mainListItems.length;

    const adminListItems = [
        { text: 'Customers', icon: <CorporateFareIcon />, url: '/customers', visibility: accessTo.ADMIN_AND_ABOVE },
        { text: 'Users', icon: <PeopleRoundedIcon />, url: '/users', visibility: accessTo.ADMIN_AND_ABOVE },
    ];


    const secondaryListItems = [
//  { text: 'Help', icon: <HelpRoundedIcon />, url: '/reference_page' },
        //  { text: 'Reference Page', icon: <InfoRoundedIcon />, url:'/reference_page' },
        //  { text: 'Feedback', icon: <HelpRoundedIcon />, url:'/reference_page' },
    ];


    function setSelectedMenuIndex(selectedMenuIndex) {
        dispatch(breadcrumbsActions.setSelectedMenuIndex(selectedMenuIndex));
    }

    function handleMenuClick(url, selectedMenuIndex) {
        history.navigate('/navigate', { state: {url: url}, replace:true});
        setSelectedMenuIndex(selectedMenuIndex);
    }

  return (
    <Stack sx={{ flexGrow: 1, p: 1 }}>
      <List dense>
        {mainListItems.map((item, index) => (
        item.visibility &&
          <Tooltip
            key={index}
            title={isCollapsed ? item.text : ""}
            TransitionComponent={Fade}
            interactive
            disableFocusListener
          >
            <ListItem disablePadding sx={{ display: 'block' }}>
              <ListItemButton component={Button}
                selected={index === selectedMenuIndex} onClick={() => handleMenuClick(item.url, index)} sx={{
                  justifyContent: isCollapsed ? 'left' : 'flex-start',
                  minHeight: 35,
                  px: isCollapsed ? 2 : 2.5,
                  padding: '8px 20px',
                  borderRadius: '5px',
                  '&:hover': {
                      width: '100%',
                      // backgroundColor: '#c0b8f2',
                      //backgroundColor: '#ece9fb',
                      backgroundColor: '#4c58b2',
                      borderRadius: '5px'
                  },
                  '&:active': {
                      width: '100%',
                      // backgroundColor: '#c0b8f2',
                      backgroundColor: '#ece9fb',
                      borderRadius: '5px',
                  },
                  '&:focus': {
                      width: '100%',
                      // backgroundColor: '#c0b8f2',
                      backgroundColor: '#ece9fb',
                      borderRadius: '5px',
                  },
                }}
              >
                <ListItemIcon  >{item.icon}</ListItemIcon>
                {/* <ListItemText primary={item.text} /> */}
                {!isCollapsed && <ListItemText primary={item.text} />}
              </ListItemButton>
            </ListItem>
          </Tooltip>
        ))}
      </List>
      {
        accessTo.ADMIN_AND_ABOVE ? (
          <List dense>
            {adminListItems.map((item, index) => (
              <Tooltip
                key={index}
                title={isCollapsed ? item.text : ""}
                TransitionComponent={Fade}
                interactive
                disableFocusListener
              >
                <ListItem disablePadding sx={{ display: 'block' }}>
                  <ListItemButton component={Button}
                    selected={(totalMainListItems + index) === selectedMenuIndex} onClick={() => handleMenuClick(item.url,totalMainListItems + index)}
                    sx={{
                        justifyContent: isCollapsed ? 'left' : 'flex-start',
                        minHeight: 35,
                        px: isCollapsed ? 2 : 2.5,
                        padding: '8px 20px',
                        borderRadius: '5px',
                        '&:hover': {
                            width: '100%',
                            // backgroundColor: '#c0b8f2',
                            //backgroundColor: '#ece9fb',
                            backgroundColor: '#4c58b2',
                            borderRadius: '5px',
                        },
                        '&:active': {
                            width: '100%',
                            // backgroundColor: '#c0b8f2',
                            backgroundColor: '#ece9fb',
                            borderRadius: '5px',
                        },
                        '&:focus': {
                            width: '100%',
                            // backgroundColor: '#c0b8f2',
                            backgroundColor: '#ece9fb',
                            borderRadius: '5px',
                        },
                    }}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    {/* <ListItemText primary={item.text} /> */}
                    {!isCollapsed && <ListItemText primary={item.text} />}
                  </ListItemButton>
                </ListItem>
              </Tooltip>
            ))}
          </List>
        ) : (<></>)
      }

      < List dense >
        {
          secondaryListItems.map((item, index) => (
            <Tooltip
              key={index}
              title={isCollapsed ? item.text : ""}
              TransitionComponent={Fade}
              interactive
              disableFocusListener
            >
              <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton component={Link}
                  to={item.url} sx={{
                    justifyContent: isCollapsed ? 'left' : 'flex-start',
                    minHeight: 35,
                    px: isCollapsed ? 2 : 2.5,
                  }}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  {/* <ListItemText primary={item.text} /> */}
                  {!isCollapsed && <ListItemText primary={item.text} />}
                </ListItemButton>
              </ListItem>
            </Tooltip>
          ))
        }
      </List>
    </Stack >
  );
}
